import { gql } from "@apollo/client";

const CREATE_OLA3_PREFILLED = gql`
  mutation createOLA3prefilled($data: [PrefilledLearningAgreementInput]) {
    createOLA3prefilled(data: $data) 
  }
`;

export default CREATE_OLA3_PREFILLED;
